import device from "current-device";
import validate from 'jquery-validation';
import DataTable from "datatables.net-dt";
import axios from "axios";

(function($, DataTable){
    const btnPay = $('#btn-payment'),
        $emailField = $('#shippingEmail'),
        $frmLogin = $('#frmLogin'),
        urlAjax = window.ajaxurl,
        spinner = getSpinner();

    if(btnPay) {
        $('#hotel_book').on('change', function(evt) {
            if($(this).is(':checked')) {
                $('.wp-hotel-reservation').removeClass('d-none');
            } else {
                $('.wp-hotel-reservation').addClass('d-none');
            }
        })

        $('#form-payment').validate({
            rules: {
                hotel_reservation: {
                    required: {
                        depends: function(element) {
                            return $("#hotel_book").is(":checked");
                        }
                    }
                }
            },
            submitHandler: function(form) {
                let type_payment = $('input[name="type_payment"]:checked').val();
                let days = $('.days:checked').map((index, day) => day.value);
                let goals = $('.goals:checked').map((index, goal) => goal.value);
                let price_open = $('#price_open');
                let data = $(form).serialize()+'&action=reg&days='+Array.from(days).join('__')+'&goals='+Array.from(goals).join('__');
                $('#btn-payment').val('Processing...');
                $('#btn-payment').prop('disabled', true);

                if(price_open.length) {
                    if(price_open.val() > 0){
                        data += '&price_open='+price_open.val()
                    } else {
                        $("html, body").animate({ scrollTop: $('#price_open').position().top+"px" });
                        $('#btn-payment').prop('disabled', false);
                        return false;
                    }
                }

                $('#form-payment .d-flex').append(spinner);
                queryAjax(urlAjax,data)
                    .done(function(response) {
                        if(response.success === true){
                            if(type_payment === 'card'){
                                document.getElementById('userCommerce').value = response.data.message;
                                document.getElementById('purchaseAmount').value = response.data.config.purchaseAmount;
                                document.getElementById('purchaseVerification').value = response.data.config.purchaseVerification;
                                document.getElementById('purchaseOperationNumber').value = response.data.config.purchaseOperationNumber;
                                document.getElementById('btn-vpos').click();
                            } else {
                                let url = document.getElementById('ajaxurl').value+`/response-cash/?purchaseOperationNumber=${response.data.config.purchaseOperationNumber}&user_id=${response.data.message}&package_id=${document.querySelector('#postID').value}`;
                                window.location.href = url;
                                return false;
                            }
                        } else {
                            $('#message-id').html(response.data.message);
                            $("html, body").animate({ scrollTop: $('#message-id').position().top+"px" });
                            $('#btn-payment').val('Payment');
                            $('#btn-payment').prop('disabled', false);
                            $('.wp-spinner').remove();
                            return false;
                        }
                    })
                    .fail(function(err) {
                        $('#form-payment .wp-spinner').remove();
                        console.log('Err', err);
                    });
                return false;
            }
        });
    }

    if($emailField) {

        if($emailField.length > 0) {
            $emailField.focus();
            $emailField.trigger('focusout');
        }

        $emailField.on('focusout', function(e){
            const data = 'shippingEmail='+$(this).val()+'&action=checkuser';
            $('#wp-loading').html('Looking for your data');
            $('#form-payment input').attr('readonly', 'readonly');
            $('#form-payment .d-flex').append(spinner);

            queryAjax(urlAjax, data)
                .done(function(response) {
                    if(response.valid) {
                        let user = response.data;
                        $('#shippingFirstName').val(user.first_name);
                        $('#shippingLastName').val(user.last_name);
                        $('#company').val(user.company);
                        $('#shippingAddress').val(user.shippingAddress);
                        $('#shippingCity').val(user.shippingCity);
                        $('#shippingCountry').val(user.shippingCountry).trigger('change');
                        $('#lbl-province').val(user.province).trigger('change');
                        $('#shippingZIP').val(user.shippingZIP);
                        $('#shippingPhone').val(user.shippingPhone);
                        $('#wp-loading').html('');
                        $('#form-payment input').removeAttr('readonly');
                        $('#form-payment .wp-spinner').remove();
                    } else {
                        $('#wp-loading').html('Your are not registered');
                        $('#form-payment input').removeAttr('readonly');
                        $('#form-payment .wp-spinner').remove();
                        return false;
                    }
                })
                .fail(function(err) {
                    console.log('Err', err);
                    $('#form-payment input').removeAttr('readonly');
                    $('#form-payment .wp-spinner').remove();
                });
        });
    }

    if($frmLogin.length) {
        $frmLogin.validate({
            submitHandler: function(form) {
                let data = $frmLogin.serialize()+'&action=login';

                queryAjax(urlAjax,data)
                    .done(function(response) {
                        if(response.valid === true){
                            window.location.href = response.redirect;
                        } else {
                            $('.error-log').html(response.data);
                            return false;
                        }
                    })
                    .fail(function(err) {
                        console.log('Err', err);
                    });
                return false;
            }
        });
    }

    if($('#tbl-my-orders').length) {
        let table = new DataTable('#tbl-my-orders');
    }

    if($('#list-packages').length && $('#qt-packages').length) {
        let packages = $('#list-packages'),
            qt = $('#qt-packages'),
            priceLabel = $('.pricePackage span');

        $('#list-packages, #qt-packages').on('change',  evt => {
            $('#postID').val(packages.val());
            $('#qt').val(qt.val());
            let price = 0;
            priceLabel.html('Loading');

            axios
                .get(urlAjax, {
                    params: {
                        action: 'calculate',
                        package: packages.val(),
                        qt: qt.val(),
                    }
                })
                .then(function (response) {
                    if(response.data.success) {
                        price = response.data.data.price;
                        priceLabel.html(price);
                        $('#purchaseAmount').val(price.toFixed(2).replace('.', ''))
                        $('.set-price').html(price+' + TAX');

                        if(response.data.data.people !== "") {
                            let table = `<h3>Name of persons</h3><p>Write everyone's name: </p> <div> <table class="table-people">${response.data.data.people}</table>`;
                            $('.wp-people').html(table)
                        } else {
                            $('.wp-people').html('')
                        }
                    } else {
                        console.log('false',response.data)
                    }
                })
                .catch(function (error) {
                    console.log('Err', error);
                });
        });

        $("#list-packages option:eq(1)").attr("selected", "selected").trigger('change');
        $('#qt').val(qt.val());
    }

    //  Functions
    const queryAjax = (url,object) => {
        return $.ajax({
            url: url,
            type: 'POST',
            data: object
        });
    }

    function getSpinner() {
        return '<div class="wp-spinner"><div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>';
    }

})(jQuery, DataTable);
